<template>
  <el-main>
    <h3 class="title">{{ newsListRes.title }}</h3>
    <div class="other_info">
      <div class="time">
        發佈時間：{{ $dayjs(newsListRes.publish_time).format("YYYY-MM-DD") }}
      </div>
    </div>
    <div v-html="newsListRes.content" class="con"></div>
    <div class="interest">
      <h4>我感興趣</h4>
      <el-form
        ref="form"
        label-width="100px"
        :inline="true"
        class="inline-form"
      >
        <el-form-item label="您的姓名：">
          <el-input v-model="name" placeholder="請輸入您的姓名"></el-input>
        </el-form-item>
        <el-form-item label="聯繫方式：">
          <el-input v-model="phone" placeholder="請輸入聯繫方式"></el-input>
        </el-form-item>
      </el-form>
      <el-form ref="form" label-width="100px">
        <el-form-item label="添加備註：">
          <el-input
            type="textarea"
            v-model="remarks"
            placeholder="添加備註"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">立即提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-main>
</template>

<script>
export default {
  data() {
    return {
      newsListRes: {},
      name: "",
      phone: "",
      remarks: "",
    };
  },
  computed: {},
  watch: {
    $route(val) {
      this.getNewsDetails();
    },
  },
  methods: {
    async getNewsDetails() {
      const { data: res } = await this.$http.get(
        `/api/v2/investInfo/${this.$route.params.id}`
      );
      if (res.code !== "200") return this.$message.error(res.msg);
      this.newsListRes = res.data;
      setTimeout(() => {
        this.$zhTran();
      }, 300);
    },
    async onSubmit() {
      if (!this.name) {
        return this.$message.error("請輸入您的姓名");
      }
      if (!this.phone) {
        return this.$message.error("請輸入聯繫方式");
      }

      const { data: res } = await this.$http.get(
        `/api/v2/investInfo/addConsult/${this.$route.params.id}`,
        {
          params: {
            name: this.name,
            phone: this.phone,
            remarks: this.remarks,
          },
        }
      );
      if (res.code !== "200") return this.$message.error(res.msg);
      if (res.code == "200")
        this.$message({
          message: res.msg,
          type: "success",
        });
      this.name = "";
      this.phone = "";
      this.remarks = "";
    },
  },
  created() {
    this.getNewsDetails();
  },
};
</script>

<style lang="less" scoped>
.el-main {
  width: 900px;
  .title {
    font-size: 22px;
    font-weight: 400;
    color: rgba(1, 1, 1, 1);
    line-height: 28px;
    text-align: center;
    margin-bottom: 18px;
    margin-top: 40px;
  }
  .other_info {
    text-align: center;
    position: relative;
    margin-bottom: 40px;
    .time {
      font-size: 16px;
      // font-weight: 300;
      color: #333333;
      line-height: 48px;
    }
    .collect {
      position: absolute;
      top: 50%;
      right: 2px;
      transform: translateY(-50%);
      i {
        font-size: 30px;
        margin-right: 18px;
      }
      .el-icon-star-on {
        color: #3135cb;
      }
      .el-button {
        font-size: 16px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        line-height: 20px;
        background: #3135cb;
        padding: 2px 14px;
        border-radius: 28px;
        border: none;
      }
    }
  }
  .con {
    color: #424242;
    font-size: 18px;
    line-height: 48px;
  }
  .con img {
    width: 100% !important;
  }
  .interest {
    h4 {
      font-size: 22px;
      font-weight: 800;
      color: rgba(1, 1, 1, 1);
      line-height: 28px;
      margin-bottom: 40px;
      margin-top: 40px;
    }
    .inline-form {
      .el-form-item {
        width: 50%;
        margin-right: 0;
      }
    }
  }
}
</style>